import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-page-heading',
  standalone: true,
  templateUrl: './page-heading.component.html',
  styleUrl: './page-heading.component.scss'
})
export class PageHeadingComponent {
  @Input() title: string | undefined;
  @Input() showLogo: boolean = false;
  @Input() setMaxWidth350: boolean = true;
}
